import axios from 'axios'
import axiosRetry from 'axios-retry'

export let baseURL;

if (!process.env.NODE_ENV || process.env.NODE_ENV === 'development') {
    const _env_ = window._env_;
    if (_env_ && _env_.ITH_INVOXIA_WS_HOST) {
        baseURL = window._env_.ITH_INVOXIA_WS_HOST
    } else {
        baseURL = 'http://127.0.0.1:8080'
    }
} else {
    if (window._env_.ITH_INVOXIA_WS_HOST) {
        baseURL = window._env_.ITH_INVOXIA_WS_HOST
    } else {
        baseURL = 'https://api.invoxia.com'
    }
}

// https://github.com/softonic/axios-retry/issues/87
const retryDelay = (retryNumber = 0) => {
    const seconds = Math.pow(2, retryNumber) * 1000;
    const randomMs = 1000 * Math.random();
    return seconds + randomMs;
};

axiosRetry(axios, {
    retries: 3,
    retryDelay,
    // retry on Network Error & 5xx responses
    retryCondition: axiosRetry.isRetryableError,
});



axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "csrftoken";
axios.defaults.headers.post['Content-Type'] = 'application/json'


export const HTTP = axios.create(
    {
        baseURL: baseURL,
        xsrfHeaderName: "X-CSRFTOKEN",
        xsrfCookieName: "csrftoken",
        xhrFields: {
            withCredentials: true
        }
    }
)

export const PUB_HTTP = axios.create(
    {
        baseURL: baseURL,
        xsrfHeaderName: "X-CSRFTOKEN",
        xsrfCookieName: "csrftoken",
    }
)

HTTP.interceptors.response.use(
    function (response) {
        return response
    },
    function (error) {

        if (error.response == undefined) {
            let vm = window.app
            vm.$router.push({name: 'error', params: {msg: error.message, route: vm.$route.name }})
        }

        const status = error.response.status
        if (status == 403 || status == 401) {
            let vm = window.app;
            let current_route = vm.$route.name;
            console.log(current_route);
            if (current_route && current_route != 'login') {
                vm.$router.push('/login?next=' + current_route);
            }

        }
        return Promise.reject(error)
    }


)


